import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  private localStorage: Storage;

  constructor() {
    this.setLocalStorage();
  }

  public get getLocalStorage(): Storage {
    return this.localStorage;
  }

  public setItem(key: string, value: string) {
    this.localStorage.setItem(key, value);
  }
  public setObject(key: string, object: any) {
    this.localStorage.setItem(key, JSON.stringify(object));
  }

  public getItem(key: string) {
    return this.localStorage.getItem(key);
  }
  public deleteItem(key: string) {
    this.localStorage.removeItem(key);
  }

  public getObject(key: string) {
    try {
      return JSON.parse(this.localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting Data for key ' + key + ' from localStore', e);
      return null;
    }
  }

  private setLocalStorage() {
    this.localStorage = (typeof window !== 'undefined') ? window.localStorage : null;
  }
}
